import * as http from '../http'
import * as Types from './types'

export default class AuditGateway {
  getAllAudit () {
    return http.GET(Types.AUDIT_GET_ALL)
  }

  getAuditById (params = {}) {
    return http.GET(Types.AUDIT_GET, params)
  }

  getAuditCreatedBy (params = {}) {
    return http.GET(Types.AUDIT_CREATED_BY, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/audit/AuditGateway.js